import React from 'react'
import  Navbar  from "../inc/Navbar";
import Develop from "../pages/Develop";
import {Link} from "react-router-dom";
import Reviews from './Reviews';
import ScrollToTop from "react-scroll-to-top"


function Ourdevelop() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <ScrollToTop smooth top="100" color="Gray" />
        <div className='websitedevelopkrishnagar'>
        <div className="album py-2">

<div className="container mt-4">
        <nav aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
    <li className="breadcrumb-item active" aria-current="page">Our Development Page</li>
  </ol>
</nav>
</div>
</div>
</div>
      
        <br/>
    
        <Develop/>
       
        <div className="album py-0">
                <div className="container">
             <h1 style={{color:"grey"}}> Reviews from Our Hon'ble Clients</h1>
                    </div>
                    </div>
        <Reviews/>
        <br/>

    </div>
  )
}

export default Ourdevelop